import { Stack, PrimaryButton } from '@fluentui/react';
import PeopleList from '../../controls/PeopleList';
import PeoplePickerCtrl, {
	SelectionType,
} from '../../controls/PeoplePickerCtrl';
import PersonalSettingsState from '../../../state/PersonalSettingsState';
import { useEffect } from 'react';
import { observer } from 'mobx-react';

function Administrators({ state }: { state: PersonalSettingsState }) {
	useEffect(() => {
		state.ensureLoaded();
	}, [state]);

	return (
		<Stack>
			<Stack.Item>
				<Stack horizontal>
					<PeoplePickerCtrl
						key={'adminpicker' + state.admins.ids.length}
						single={true}
						selectionType={SelectionType.User}
						selectedIds={state.admins.pending}
						onSelectionChanged={(ids) => {
							state.admins.addPending(ids);
						}}
					/>

					<PrimaryButton
						disabled={state.admins.pending.length === 0}
						style={{ margin: '10px' }}
						iconProps={{ iconName: 'PeopleAdd' }}
						onClick={() => {
							state.admins.applyPending();
						}}
					>
						Add administrator
					</PrimaryButton>
				</Stack>
			</Stack.Item>
			<Stack.Item grow>
				<div style={{ width: '100%', maxWidth: '800px' }}>
					<PeopleList state={state.admins}></PeopleList>
				</div>
			</Stack.Item>
		</Stack>
	);
}

export default observer(Administrators);
